import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  FormGroup,
  Button,
  Label,
  Spinner,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import cellEditFactory from "react-bootstrap-table2-editor";

import { postSubmitForm } from "../../../helpers/forms_helper";
import { convertToLowestUnit, formatUnitsForReport, GetUpdatedDelivered } from "../../../helpers/units";
import showNotification from "../../../helpers/show_notification";
import calculatePrice from "../../../helpers/calculate_price";
import UpdateQuantityModal from "../../../components/UpdateQuantityModal";

const BranchPOGeneration = (props) => {
  const [branchID, setBranchID] = useState();
  const [requestID, setRequestID] = useState();
  const [branchName, setBranchName] = useState();
  const [hideActions, setHideActions] = useState(true);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("id")) {
      loadPOData({ id: urlParams.get("id") });
      setRequestID(urlParams.get("id"));
    }
    if (urlParams.get("branch_id")) {
      setBranchID(urlParams.get("branch_id"));
    }
    if (urlParams.get("branch_name")) {
      setBranchName(urlParams.get("branch_name"));
    }
  }, []);

  const [allItems, setAllItems] = useState([]);
  const loadPOData = async (data) => {
    let url = process.env.REACT_APP_BASEURL +
      "branchporequests/get_by_id_with_suppliers";
    const response = await postSubmitForm(url, data);

    if (response && response.status === 1) {
      if (response.data.status == "Pending") {
        setHideActions(false);
      }
      let requestedItems =  response.data?.requested_items
      requestedItems.forEach((requestedItem, itemIndex) => {
        requestedItem.suppliers = requestedItem.suppliers.map(supplier => ({
          ...supplier,
          value: supplier._id
        }));
        requestedItem.supplier = requestedItem.suppliers[0]?._id
        requestedItem.items.forEach(item => {
          item.original_quantity = item.quantity
            item.quantity.forEach((quantity, quantityIndex) => {
                quantity.index = quantityIndex;
                quantity.isChecked = true;
            });
        });
    });
// console.log(requestedItems);
      setAllItems(requestedItems);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const loadSuupliers = async (e) => {
    let url = process.env.REACT_APP_BASEURL + "suppliers/get_by_categories";
    let response = await postSubmitForm(url, {categories:[e.category]});
    if (response.status === 1) {
      const supplier = response.data.sort((a,b)=>a.name.localeCompare(b.name))
      const UpdatedWithSupplier = allItems.map(item =>
        item.category === e.category
          ? { ...item, 
            suppliers:supplier,
            supplier: item.supplier || e.supplier,
          }
          : item
      );
      setAllItems(UpdatedWithSupplier);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const handleSupplierSelection = (e,item) =>{
    const selectedSupplierName = e.target.value;
    setAllItems((prev) =>
      prev.map((itm) =>
        itm.category === item.category
          ? { ...itm, supplier: selectedSupplierName }
          : itm
      )
    );
    }
  const [selectedItem, setSelectedItem] = useState([]);
  const [editUnitModal, setEditUnitModal] = useState(false);

  const handleUpdateQuantity = (quantity) => {
    const updatedAllItems = allItems.map(category => {
      let convertedQuantity =  GetUpdatedDelivered(quantity, selectedItem?.unit_levels)
      setSelectedItem(prev => {
        return { ...prev, quantity: convertedQuantity };
      });  
      if (category.category === selectedItem.category) {
        const updatedItems = category.items.map(item =>
          item.item_id === selectedItem.item_id ? {
            ...item,
            quantity: convertedQuantity,
            total_price: calculatePrice(item.unit_levels, convertedQuantity, item.price, item.unit_for_po),
          } : item
        );
        return { ...category, items: updatedItems };
      }
      return category;
    });
    setAllItems(updatedAllItems);
    setEditUnitModal(false);
  };
  // const handlePriceChange = (e) => {
  //   const isItemInCart = allItems.some(category =>
  //     category.items.some(item => item.item_id === selectedItem.item_id)
  //   );

  //   if (isItemInCart) {
  //     const updatedAllItems = allItems.map(category => {
  //       const updatedItems = category.items.map(item =>
  //         item.item_id === selectedItem.item_id
  //           ? { ...item, price: +e.target.value }
  //           : item
  //       );
  //       return { ...category, items: updatedItems };
  //     });
  //     setAllItems(updatedAllItems);
  //   }
  // };
  const columns_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "22%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Brand"),
      dataField: "brand",
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
            <div className="d-flex align-items-center justify-content-between">
            <span className="me-2">
                {formatUnitsForReport(row.quantity)}
              </span>
                <Button
                  className="btn btn-success btn-sm"
                  onClick={() => {
                    setSelectedItem(row)
                    setEditUnitModal(true);
                  }}
                  hidden={hideActions}
                >
                  <i class="mdi mdi-edit"></i>
                  {props.t("Edit")}
                </Button>
            </div>
          </>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
      footer: false,
    },
    {
      text: props.t("Price"),
      dataField: "price",
      formatter: (cell, row) => {
        return row.price + "/" + row.unit_for_po
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: !hideActions,
      type:"number",
      editor: {
        type: "number", 
      },
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: 'Price should be numeric'
          };
        }
        if (newValue < 0.1) {
          return {
            valid: false,
            message: 'minimum 0.1 '
          };
        }
        return true;
      },
      attrs: (cell, row, rowIndex, colIndex) => {
        const title_text = { title: "Click to Edit" };
        return title_text;
      },
      style: (cell, row, rowIndex, colIndex) => {
        const cur_style = { cursor: "pointer" };
        return cur_style;
      },
    },
    {
      text: props.t("Total"),
      dataField: "total_price",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
  ];
  function compareQuantities(item) {
    const quantities = item.original_quantity;
    const quantitiesToCompare = item.quantity;
    const unitLevels = item.unit_levels;
    const convertedQuantities = convertToLowestUnit( unitLevels,quantities);
    const convertedQuantitiesToCompare =  convertToLowestUnit( unitLevels,quantitiesToCompare);
    let isChanged = false;
      if (convertedQuantities !== convertedQuantitiesToCompare) {
        isChanged = true;
      }      
    return isChanged;
  }

  const [isLoading, setIsLoading] = useState(false)
  const handleSubmitRequisition = async () => {
    let payload = allItems.map((category) => ({
      category: category.category,
      supplier:category.supplier,
      items: category.items.map((item) => ({
        item_id: item.item_id,
        is_requested_quantity_updated:compareQuantities(item),
        name: item.name,
        category: item.category,
        sub_category: item.sub_category,
        brand: item.brand,
        unit_for_po: item.unit_for_po,
        unit_levels:item.unit_levels,
        quantity: item.quantity.map(({ unit, value }) => ({ unit, value })) || null, 
        price: +item.price,
        total_price: +item.total_price,
              }))}))

      if (allItems.some((category) => category.supplier === "")) {
        showNotification("Please select a supplier for each category", "Warning");
        return;
      }else if (allItems.some((category) =>
        category.items.some((item) =>
          item.quantity.length > 0 && item.quantity.every(({ value }) => (value == "0" || value == 0 || value === ""))
        )
      )) {
        showNotification("Please enter a valid quantity for at least one unit", "Warning");
        return;
      }
      try {
        if (allItems?.length > 0) {
          setIsLoading(true)
          let url = process.env.REACT_APP_BASEURL + "purchaseorders/insert";
          let data_to_send = {
            request_id: requestID,
            branch_id: branchID,
            deliver_at_branch: true,
            items: payload,
          }          
          let response = await postSubmitForm(url,data_to_send);
          if (response.status === 1) {
            setHideActions(true);
            showNotification(response.message, "Success");
            setTimeout(()=>{
              window.location.reload();
            },800)
            for (let i = 0; i < response.data.length; i++) {
              window.open(
                `/purchase_order?po_id=${response.data[i]}`,
                "_blank"
              );
            }
          } else {
            showNotification(response.message, "Error");
          }
        } else {
          showNotification(
            "Please select at least one item and supplier.",
            "Error"
          );
        }
      } catch (error) {
        showNotification(error.message, "Error");
      } finally {
        setIsLoading(false)
      }
  };
  
  const handleRejectRequest = async () => {
    let url = process.env.REACT_APP_BASEURL + "branchporequests/reject";

    let response = await postSubmitForm(url, {
      request_id: requestID,
    });
    if (response.status === 1) {
      setHideActions(true);
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Branch PO Generation")}
            title={props.t("Procurement")}
            breadcrumbItem1={props.t("Branch PO Generation")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={12}>Branch Name: {branchName && branchName}</Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {allItems.map((item) => {
                    return (
                      <>
                        <Row>
                          <Col lg={8} md={8} sm={8}>
                            <Label>Category: {item.category}</Label>
                          </Col>
                          {/* <Col lg={6}>
                            <Label>Supplier: {item.suppliers[0].name}</Label>
                          </Col> */}
                          <Col lg={4} md={4} sm={4}>
                                        <AvForm>
                                          <AvField
                                            name="supplier"
                                            type="select"
                                            disabled={hideActions}
                                            value={item.supplier}  
                                            onClick={() => loadSuupliers(item)}
                                            onChange={(e) =>{
                                              handleSupplierSelection(e, item);
                                            }}
                                          >
                                            <option value="">
                                              {props.t("--Select Supplier--")}
                                            </option>
                                            {item.suppliers &&
                                              item.suppliers.map((e) => (
                                                <option
                                                  key={e.value}
                                                  value={e.value}
                                                  // name={e._id}
                                                >
                                                  {e.name}
                                                </option>
                                              ))}
                                          </AvField>
                                        </AvForm>
                                      </Col>
                        </Row>
                        <BootstrapTable
                          bootstrap4
                          keyField="item_id"
                          data={item.items}
                          columns={columns_items}
                          cellEdit={cellEditFactory({
                            mode: "click",
                            blurToSave: true,
                            afterSaveCell: (oldValue, newValue, row, column) => {
                              row.total_price=calculatePrice(row.unit_levels, row.quantity, row.price, row.unit_for_po)
                             }
                          })}
                          noDataIndication="No data to display."
                          striped
                          hover
                          condensed
                        />
                        <hr />
                      </>
                    );
                  })}
                  <Row>
                    <Col lg={12}>
                      <FormGroup className="mb-0 text-center">
                        <div>
                          <Button
                            type="submit"
                            color="primary"
                            className="mr-1"
                            style={{width:"110px"}}
                            onClick={handleSubmitRequisition}
                            hidden={hideActions}
                            disabled={isLoading}
                          >
                            {isLoading ? <Spinner size="sm" /> : props.t("Approve")}
                          </Button>
                          <Button
                            type="submit"
                            color="danger"
                            style={{width:"110px"}}
                            onClick={handleRejectRequest}
                            hidden={hideActions}
                          >
                            {props.t("Reject")}
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
               
                </CardBody>
              </Card>
            </Col>
               {/* Edit Quantity Modal  */}
        
           <UpdateQuantityModal 
                   isOpen={editUnitModal}
                   toggle={()=>setEditUnitModal(false)}
                   onSubmit={handleUpdateQuantity}
                   item={selectedItem}
                  />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(BranchPOGeneration))
);
